// extracted by mini-css-extract-plugin
export default {"wrapper":"toggle-tab_wrapper__fWX98","button":"toggle-tab_button__FP4qb"};